import appConfig from '~/config/app'
import { encodeRequestBody } from '~/utils/format'

import { hexToRGB } from '../Metadata/Metadata.util'

import type { ServerlessImageHandlerEdits, ServerlessCombineImagesHandlerParams, ResizeFit, Resize } from './types'

interface ColorCode {
  hex: string
  alpha?: number
}

export function getServerlessImageHandlerUrl({
  bucket = 'hom-frontend-assets',
  key,
  edits,
  isSvg,
}: {
  bucket?: string
  key: string
  edits: ServerlessImageHandlerEdits | undefined
  isSvg?: boolean
}): string {
  // SVGs don't need SIH processing, use the default CDN.
  if (isSvg) {
    return `${appConfig.assetsCdnUrl}/${key}`
  }

  const requestBody = JSON.stringify({
    bucket,
    key,
    edits,
  })

  return `${appConfig.imagesCdnUrl}/${encodeRequestBody(requestBody)}`
}

export function getServerlessCombineImagesHandlerUrl({
  bucketKey = 'hom-frontend-assets',
  fileKeys,
  size,
  outFileKey,
}: ServerlessCombineImagesHandlerParams): string {
  const requestBody = JSON.stringify({
    bucketKey,
    fileKeys,
    size,
    outFileKey,
  })

  return `${appConfig.combineImagesCdnUrl}/${encodeRequestBody(requestBody)}`
}

export function getImageUrl(
  height: number | undefined,
  width: number | undefined,
  fit: ResizeFit,
  srcKey: string,
  bucket: string | undefined,
  background: ColorCode = { hex: '#000000' }, // Default fill color is black i.e. #000
): { urlOriginal: string; urlWithFormat: string } {
  const isSvg = srcKey?.endsWith('.svg')
  let editsOriginal: ServerlessImageHandlerEdits | undefined = {}
  let editsWithFormat: ServerlessImageHandlerEdits | undefined = {}

  if ((typeof height === 'number' || typeof width === 'number') && !isSvg) {
    const resize: Resize = {
      fit,
      background: hexToRGB(background.hex, background.alpha),
    }
    if (typeof height === 'number') {
      resize.height = height
    }
    if (typeof width === 'number') {
      resize.width = width
    }

    editsOriginal = {
      resize,
    }
    editsWithFormat = {
      ...editsOriginal,
      toFormat: 'webp',
    }
  }

  const params = {
    bucket,
    key: srcKey,
    isSvg,
  }

  const urlOriginal = getServerlessImageHandlerUrl({
    ...params,
    edits: editsOriginal,
  })

  const urlWithFormat = getServerlessImageHandlerUrl({
    ...params,
    edits: editsWithFormat,
  })

  return { urlOriginal, urlWithFormat }
}
